import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { EntityReadingDataGrid } from './EntityReadingDataGrid';
const debug = process.env.REACT_APP_DEBUG && false;
export default function ObjectHistoryTableCard(props) {
    const { viewObject: viewObjectIn, objectHistory, contextCustomer, filterMetricKeys } = props;
    debug && console.log('ObjectHistoryTableCard', props);
    const historyStore = objectHistory?.recentStateHistory ?? objectHistory?.dailyStateHistory;
    return viewObjectIn.matchedPrimary !== undefined && historyStore !== undefined ? (_jsx(EntityReadingDataGrid, { filterMetricKeys, context: { mostProximateCustomer: contextCustomer, contextObject: viewObjectIn.matchedPrimary, historyStore }, seeExport: true })) : (_jsx(_Fragment, {}));
}
